import { ACTION_CONSTANTS } from 'actions/constants';

const INITIAL_STATE = { loading: 0, customLoaders: {}, customLoading: 0 };

export function loader(state = INITIAL_STATE, action) {
  switch (action.type) {
    case ACTION_CONSTANTS.loader.open:
      const openCustomLoader = action.payload.customLoader;

      if (openCustomLoader) {
        const customLoaders = Object.assign({}, state.customLoaders, {
          [openCustomLoader]: state.customLoaders[openCustomLoader]
            ? state.customLoaders[openCustomLoader] + 1
            : 1
        });
        return Object.assign({}, state, {
          loading: state.loading + 1,
          customLoaders,
          customLoading: state.customLoading + 1
        });
      } else {
        return Object.assign({}, state, { loading: state.loading + 1 });
      }
    case ACTION_CONSTANTS.loader.close:
      const closedCustomLoader = action.payload.customLoader;

      if (closedCustomLoader) {
        const customLoaders = Object.assign({}, state.customLoaders, {
          [closedCustomLoader]: state.customLoaders[closedCustomLoader]
            ? state.customLoaders[closedCustomLoader] - 1
            : 0
        });
        return Object.assign({}, state, {
          loading: state.loading - 1,
          customLoaders,
          customLoading: state.customLoading - 1
        });
      } else {
        return Object.assign({}, state, { loading: state.loading - 1 });
      }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/loader.js